module.exports = __webpack_public_path__ + "static/pew-f27ab7c4a9706827d559f7565d103142.png";